import cookieUtil from './cookieUtil';
import userAgentHelper from '../library/userAgentHelper';
import urlParse from '../library/urlParse';
/**************** 处理第三方渠道 ****************/
// 加上查询参数: partnervip 存入cookie: partnervip
const BrowserEnum = userAgentHelper.BrowserEnum;
// 第三方渠道
let source = {
  [BrowserEnum.UNIONPAY]: 'yinlian'
}[userAgentHelper.browser];
// 如果是从第三方渠道进入,url带上第三方渠道utm参数
if (source) {
  const urlObj = urlParse();
  // 查询参数没有partnervip
  if (!urlObj.query.partnervip) {
    const search = (urlObj.search.length > 0 ? urlObj.search : '?') + '&partnervip=' + source;
    window.history.replaceState({}, "", `${urlObj.origin + urlObj.pathname + search + urlObj.hash}`);
  }
}

source = source || urlParse().query.partnervip;
if (source) {
  cookieUtil.setCookie('partnervip', source);
}



// WEBPACK FOOTER //
// ./src/library/partnervip.js